import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const TopContentWrapper = styled.div`
  display: flex;
  @media (${mediaQuery.tablet}) {
    flex-direction: column;
  }
`;

export const LeftContainer = styled.div`
  width: 750px;
  @media (${mediaQuery.tablet}) {
    width: 100%;
    margin: 0;
  }
`;

export const AsideContainer = styled.div`
  flex-grow: 1;
  margin: 0 0 0 30px;
  @media (${mediaQuery.tablet}) {
    width: 100%;
    margin-left: 0;
  }
`;
